<p-button
  [attr.data-testid]="id() + '-button'"
  [icon]="icon() ?? ''"
  [label]="text() ? (text()! | transloco) : undefined"
  [disabled]="disabled()"
  [text]="true"
  [severity]="active() ? 'success' : null"
  [styleClass]="styleClass()"
  [pTooltip]="tooltipText()"
  [escape]="false"
  [tooltipPosition]="tooltipPosition()"
  appendTo="body"
  tooltipStyleClass="tooltip-bg-third-level directus-tooltip model-field-button-tooltip"
  (onClick)="clicked.emit()"
/>
